import * as THREE from "../../build/three.module.js";
import { SkeletonUtils } from "../../examples/jsm/utils/SkeletonUtils.js";
import { OrbitControls } from "../../examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "../../examples/jsm/loaders/GLTFLoader.js";
import { EffectComposer } from "../../examples/jsm/postprocessing/EffectComposer.js";
import { TWEEN } from "../../examples/jsm/libs/tween.module.min.js";
import { RenderPass } from "../../examples/jsm/postprocessing/RenderPass.js";
import { OutlinePass } from "../../examples/jsm/postprocessing/OutlinePass.js";
import { FXAAShader } from "../../examples/jsm/shaders/FXAAShader.js";
import { ShaderPass } from "../../examples/jsm/postprocessing/ShaderPass.js";
import { UnrealBloomPass } from "../../examples/jsm/postprocessing/UnrealBloomPass.js";
import { RoughnessMipmapper } from '../../examples/jsm/utils/RoughnessMipmapper.js';
import { RGBELoader } from '../../examples/jsm/loaders/RGBELoader.js';
import { CSS2DRenderer, CSS2DObject } from '../../examples/jsm/renderers/CSS2DRenderer.js';

//import { CSS3DRenderer, CSS3DObject } from '../../examples/jsm/renderers/CSS3DRenderer.js';
import { render } from "less";
import { ssrCompile } from "vue-template-compiler";
// import { SSAOPass } from "../../examples/jsm/postprocessing/SSAOPass.js";
// import { GUI } from "../../examples/jsm/libs/dat.gui.module.js";
class ThreeDimensional {
    constructor(divName, isAlpha = false, infoIndex = 0, CMType) {
        const scope = this;
        //画布
        this.canvas = null;
        //摄像机
        this.camera = null;
        //场景
        this.scene = null;
        //渲染器
        this.renderer = null;
        //控制器
        this.controls = null;
        //Editor控制器
        this.controls_Editor = null;
        //特效图层
        this.composer = null;
        //环境反射
        this.environment = null;
        //不知道是什么
        this.roughnessMipmapper = null;
        //天空盒
        this.skyBox = null;
        this.WorkShop = null;
        this.divArray = [];
        this.divLabel = [];
        this.animateID = null;
        this.labelRenderer_2d = null;
        this.labelRenderer_3d = null;
        this.Model = null;
        this.clock = null;
        this.delta = null;
        this.mixer = [];
        this.action = [];
        this._mixer = null;
        //this.InfoTitle = null;
        this.cubeArray = [];
        this.PointPos = { x: 0, y: 0 };
        //                   0       1        2       3       4        5       6         7       8       9        10      11    12        13
        this.ModelSize = [3522308, 2082600, 853740, 690760, 743796, 1822796, 1331380 /*1626100*/, 1236252, 1237496, 855324, 424884, 4077616, 790520, 674984, 5748856]
        this.ConveyorBeltUV = [];
        this.ConveyorBeltUV_2 = [];
        this.ConveyorBeltUV_3 = [];
        this.ConveyorBeltUV_4 = [];
        this.AllModel = [];
        this.cM = null;
        this.mTipsClone = [];
        this.tips = [];
        this.MCId = [];
        this.MCIndex = null;
        this.isMoveType = [];
        //                      0       1           2       3           4       5       6                   7           8       9           10          11               12          13
        this.deviceName = ['上料系统', '搅拌机', '涂布机', '辊压机', '分条机', '模切机', '叠片机'/*'卷绕机'*/, '预焊机', '终焊机', '封口测试一体机', '烘烤机', '注液预封机', '化成机', '抽气二封机', '负压化成机']
        this.AloneCameraPos = [
            { x: -17.173372990027726, y: 0.8720615459229256, z: 3.219493062476956 },
            { x: -15.156643138429187, y: 1.0796715967281216, z: 3.554139166714637 },
            { x: -10.388588179372631, y: 0.5980521563827583, z: 2.6806266851759117 },
            { x: -8.03039809365325, y: 0.1036820092631193, z: 0.9631934305089946 },
            { x: -7.191784001968708, y: 0.26303440909061593, z: -2.228362581697471 },
            { x: -2.353986731561936, y: 0.5561475615036598, z: 2.217485640893616 },
            { x: 0.7738433769453364, y: 0.31101926624214693, z: 1.4296826460254328 },   //6
            { x: 2.334440302446654, y: 0.6458941799058007, z: 2.107780474411222 },
            { x: 4.519631056597018, y: 0.7381263719870363, z: 2.3660211204191253 },
            { x: 5.753401348096064, y: 0.6282363690862002, z: 1.8242395455743985 },
            { x: 7.86956737073675, y: 0.5390604621371202, z: 1.4380430956492691 },
            { x: 9.886447601850849, y: 0.5352026882723061, z: 1.6108127550555107 },
            { x: 12.817343178272791, y: 0.5251680964618314, z: 2.1302699128260114 },
            { x: 15.044758557547492, y: 0.292065945708249, z: 1.1293491738849446 },
            {  x: 17.245266282184037, y: 0.573711052148455, z: 1.768010433908381 },
        ];

        this.AloneControlsTarget = [
            { x: -15.226187169586874, y: 1.193770924962755, z: -1.2789075316563465 },
            { x: -15.034790338720272, y: 1.313273984944277, z: -1.3510845049041993 },
            { x: -10.41813904328723, y: 0.7581775768199933, z: -1.3171532612430348 },
            { x: -7.148069470295147, y: 0.23155402032005953, z: -1.2602282301288574 },
            { x: -4.8310017845070705, y: 0.34639761788477386, z: -1.239302369331816 },
            { x: -2.30679726634376, y: 0.45533904129532526, z: -1.2645905716341388 },
            { x: 0.7989157130274487, y: 0.39345469027376445, z: -1.2646803722354392 },  //6
            { x: 2.978146632636759, y: 0.6512005572758737, z: -1.469905807922503 },
            { x: 4.649345638622453, y: 0.6445889502751967, z: -1.0930546438980282 },
            { x: 6.828760022217185, y: 0.639438610926606, z: -1.3058308848722548 },
            { x: 8.873768715043138, y: 0.5366684392314756, z: -1.3750625800895147 },
            { x: 11.119497296751282, y: 0.606713622517879, z: -1.108831383566924 },
            { x: 13.757821850467272, y: 0.49028177731133243, z: -1.0427641997655808 },
            { x: 16.47265299397881, y: 0.430600470578855, z: -1.3189198640145299 },
            { x: 18.47, y: 0.430600470578855, z: -1.3189198640145299 },

        ];
        /*
        上料系统
        搅拌机
        涂布机
        辊压机
        分条机
        模切机
        叠片机
        预焊机
        终焊机
        封口测试一体机
        烘烤机
        注液预封机
        化成机
        抽气二封机

        卷绕机
        */
        scope.MCId['上料系统'] = 'MC001';
        scope.MCId['搅拌机'] = 'MC002';
        scope.MCId['涂布机'] = 'MC003';
        scope.MCId['辊压机'] = 'MC004';
        scope.MCId['分条机'] = 'MC005';
        scope.MCId['模切机'] = 'MC006';
        scope.MCId['叠片机'] = 'MC007';
        scope.MCId['预焊机'] = 'MC008';
        scope.MCId['终焊机'] = 'MC009';
        scope.MCId['烘烤机'] = 'MC010';
        scope.MCId['注液预封机'] = 'MC011';
        scope.MCId['化成机'] = 'MC012';
        scope.MCId['抽气二封机'] = 'MC013';
        scope.MCId['封口测试一体机'] = 'MC014';
        scope.MCId['卷绕机'] = 'MC015';
        scope.MCId['负压化成机'] = 'MC017';
        //辉光图层参数
        this.boomparams = {
            exposure: 0.3,
            bloomStrength: 0.3,
            bloomThreshold: 0,
            bloomRadius: 0.2,
        };

        let testobj;

        Start();
        /**
         * @
         * Start函数
         * 初始时调用一次
         */
        function Start() {

            //初始化场景
            onLoad();
            //初始化特效图层
            //initBloomComposer();
            //initSSAOComposer();
            LoadEnvironmentTexture();
            //LoadSceneTexture();
            if (!isAlpha) {
                LoadSceneTexture();
                const girdHelper = new THREE.GridHelper(60, 60);
                girdHelper.scale.set(1, 1, 1);
                var Linematerial = new THREE.LineBasicMaterial({
                    color: 0x636363,
                    linewidth: 1,
                    linecap: 'round', //ignored by WebGLRenderer
                    linejoin: 'round' //ignored by WebGLRenderer
                });
                girdHelper.material = Linematerial;
                girdHelper.position.set(0, -.5, 0);
                scope.scene.add(girdHelper);
                LoadGLBModel_other('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/tips.glb');
                LoadGLBModel('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/场景.glb', 20);
                //LoadGLBModel('https://zhuoke211025.oss-cn-shenzhen.aliyuncs.com/Lionsystem/model/14负压化成机.glb', 15);
                SetControlsKey(0);
            } else {

                SetcMType(CMType);
                ChangeModel_init(infoIndex);
            }
        }
        /**
         * @
         * 初始加载
         * 初始化画布
         * 初始化场景
         * 初始化渲染器
         * 初始化摄像机
         * 初始化控制器
         * 初始化特效通道
         */
        function onLoad() {
            //获取画布
            scope.canvas = document.getElementById(divName);
            //初始化场景
            scope.scene = new THREE.Scene();
            //scope.scene.background =new THREE.Color(0x7c7c7c)
            //初始化渲染器
            scope.renderer = new THREE.WebGLRenderer({
                antialias: true,
                alpha: isAlpha,
            });
            scope.renderer.setPixelRatio(window.devicePixelRatio);

            scope.renderer.setSize(scope.canvas.clientWidth, scope.canvas.clientHeight);
            //scope.renderer.outputEncoding = THREE.sRGBEncoding;
            //scope.renderer.physicallyCorrectLights = true;

            //添加画布到div
            scope.canvas.appendChild(scope.renderer.domElement);

            //初始化摄像机
            scope.camera = new THREE.PerspectiveCamera(60, scope.canvas.clientWidth / scope.canvas.clientHeight, 0.1, 5000);
            scope.camera.position.set(-0.59, 0.08, 0.41);

            //添加环境灯光
            const light = new THREE.AmbientLight(0xffffff, 1); // soft white light
            scope.scene.add(light);

            //添加平行灯光
            // const directionalLight = new THREE.DirectionalLight(0xffffff, 0.2);
            // scope.scene.add(directionalLight);

            //初始化特效图层通道
            scope.composer = new EffectComposer(scope.renderer);

            //初始化时钟
            scope.clock = new THREE.Clock();

            //初始化CSS2D
            scope.labelRenderer_2d = new CSS2DRenderer();
            scope.labelRenderer_2d.setSize(window.innerWidth, window.innerHeight);
            scope.labelRenderer_2d.domElement.style.position = 'absolute';
            scope.labelRenderer_2d.domElement.style.top = '0px';
            scope.canvas.appendChild(scope.labelRenderer_2d.domElement);
            //scope.labelRenderer_2d.domElement.style.pointerEvents = 'none';

            //初始化控制器
            scope.controls = CretaeControls(scope.labelRenderer_2d.domElement, !isAlpha);
            scope.controls_Editor = CretaeControls(scope.renderer.domElement, isAlpha);
            scope.controls_Editor.maxDistance = 100;
            scope.controls_Editor.mouseButtons =
            {
                LEFT: !isAlpha ? THREE.MOUSE.PAN : THREE.MOUSE.ROTATE,
                MIDDLE: THREE.MOUSE.DOLLY,
                RIGHT: !isAlpha ? THREE.MOUSE.ROTATE : THREE.MOUSE.PAN
            }
            /*scope.controls = new OrbitControls(scope.camera, scope.labelRenderer_2d.domElement);
            //scope.controls = new OrbitControls(scope.camera, home);
            scope.controls.enableDamping = true;
            scope.controls.minDistance = 0;
            scope.controls.maxDistance = 500;*/
            scope.controls.target.set(0.54, -0.04, -0.21);
            scope.controls.maxPolarAngle = .5 * Math.PI
            scope.controls_Editor.target.set(0.54, -0.04, -0.21);
            if (isAlpha) {
                scope.labelRenderer_2d.domElement.style.pointerEvents = 'none';
                scope.controls_Editor.enabled = true;
                scope.controls.enabled = false;
                scope.camera.position.set(scope.AloneCameraPos[0].x, scope.AloneCameraPos[0].y, scope.AloneCameraPos[0].z)
                scope.controls_Editor.target.set(scope.AloneControlsTarget[0].x, scope.AloneControlsTarget[0].y, scope.AloneControlsTarget[0].z)
                scope.controls_Editor.autoRotate = true;
            }
            //添加动态响应函数
            window.addEventListener("resize", onWindowResize);

            //添加点击监听
            window.addEventListener("pointerdown", pointerdown);

            update();
        }

        function pointerdown(event) {
            scope.PointPos = { x: event.clientX, y: event.clientY };
        }

        this.GetPosition = () => {
            return scope.PointPos;
        }

        function initSSAOComposer() {
            const ssaoPass = new SSAOPass(scope.scene, scope.camera, scope.canvas.clientWidth, scope.canvas.clientHeight);
            ssaoPass.kernelRadius = 0.5;
            ssaoPass.output = SSAOPass.OUTPUT.Default;
            ssaoPass.minDistance = 0.01;
            ssaoPass.maxDistance = 0.02;
            scope.composer.addPass(ssaoPass);

            const gui = new GUI();

            gui.add(ssaoPass, 'output', {
                'Default': SSAOPass.OUTPUT.Default,
                'SSAO Only': SSAOPass.OUTPUT.SSAO,
                'SSAO Only + Blur': SSAOPass.OUTPUT.Blur,
                'Beauty': SSAOPass.OUTPUT.Beauty,
                'Depth': SSAOPass.OUTPUT.Depth,
                'Normal': SSAOPass.OUTPUT.Normal
            }).onChange(function (value) {

                ssaoPass.output = parseInt(value);

            });
            gui.add(ssaoPass, 'kernelRadius').min(0).max(1000);
            gui.add(ssaoPass, 'minDistance').min(0.001).max(1000);
            gui.add(ssaoPass, 'maxDistance').min(0.01).max(10);
        }

        function initBloomComposer() {
            const renderScene = new RenderPass(scope.scene, scope.camera);
            //光晕
            const bloomPass = new UnrealBloomPass(
                new THREE.Vector2(scope.canvas.clientWidth, scope.canvas.clientHeight),
                0.1,
                0.0,
                0.05
            );
            bloomPass.threshold = scope.boomparams.bloomThreshold;
            bloomPass.strength = scope.boomparams.bloomStrength;
            bloomPass.radius = scope.boomparams.bloomRadius;
            scope.composer.addPass(renderScene);
            scope.composer.addPass(bloomPass);
        }

        function onWindowResize() {
            scope.onWindowResize();
        }

        this.onWindowResize = () => {
            if (scope.camera == null) return;
            scope.camera.aspect = scope.canvas.clientWidth / scope.canvas.clientHeight;
            scope.camera.updateProjectionMatrix();
            scope.renderer.setSize(scope.canvas.clientWidth, scope.canvas.clientHeight);
            scope.composer.setSize(scope.canvas.clientWidth, scope.canvas.clientHeight);
            scope.labelRenderer_2d.setSize(window.innerWidth, window.innerHeight);
        }

        /**
         *
         * 加载模型函数
         */
        function LoadGLBModel(url, index = 0) {
            let loader = new GLTFLoader();
            let luvArr = [];
            let guvArr = [];
            let gduvArr = [];
            let gluvArr = [];
            loader.load(url, function (model) {
                model.scene.traverse(function (child) {
                    if (child.isMesh) {
                        if (child.name.indexOf('waike') != -1) {
                            let line = CreateLine(child);
                            child.add(line);
                        }
                        if (child.name.indexOf('liudongjiantou') == 0) {
                            //scope.ConveyorBeltUV.push(child.material.map);
                            luvArr.push(child.material.map);
                        }
                        if (child.name.indexOf('隔膜') == 0) {
                            //scope.ConveyorBeltUV_2.push(child.material.map);
                            guvArr.push(child.material.map);
                        }
                        if (child.name.indexOf('guandao') == 0) {
                            //scope.ConveyorBeltUV_3.push(child.material.map);
                            gduvArr.push(child.material.map);
                        }
                        if (child.name.indexOf('gdlong') == 0) {
                            //scope.ConveyorBeltUV_4.push(child.material.map);
                            gluvArr.push(child.material.map);
                        }
                        child.material.envMap = scope.environment;
                    }

                })
                scope.ConveyorBeltUV[index] = luvArr;
                scope.ConveyorBeltUV_2[index] = guvArr;
                scope.ConveyorBeltUV_3[index] = gduvArr;
                scope.ConveyorBeltUV_4[index] = gluvArr;

                scope.scene.add(model.scene);
                scope.Model = model.scene;
                scope.AllModel[index] = model.scene;
                if (index == scope.divArray.length && scope.divArray.length > 0) {
                    scope.AllModel[scope.divArray.length].visible = false;
                    scope.mixer[index] = new THREE.AnimationMixer(model.scene);
                    scope.action[index] = scope.mixer[index].clipAction(model.animations[0]);
                    scope.action[index].play();
                    SetcMType(cMType);
                }

                if (model.scene.children[0].name == '场景') {
                    scope.WorkShop = model.scene;
                    scope.ShowWorkShop(false);
                }
                if (index == null) {
                    model.scene.position.set(0, 0, 0);
                    model.scene.children[0].position.set(0, 0, 0);
                }
                if (scope.divArray.length != 0) {
                    if (document.getElementById(scope.divArray[index]) == undefined) {
                        return;
                    }
                    // if (index > 14 ) {
                    //     return
                    // }
                    const infoDiv = document.getElementById(scope.divArray[index]);
                    let InfoTitle = infoDiv.getElementsByClassName('machine-box')[0].getElementsByClassName('machine-title')[0];
                    let infoDetails = InfoTitle.getElementsByClassName('check')[0];
                    if (index == 6) {
                        let cMachine = document.getElementById('cMachine');
                        cMachine.style.pointerEvents = "auto";
                        scope.cM = new CSS2DObject(cMachine);
                        scope.cM.position.set(model.scene.children[0].position.x,
                            model.scene.children[0].position.y - 0.65,
                            model.scene.children[0].position.z + 0.6);
                        model.scene.add(scope.cM);
                        scope.cM.visible = false;
                    }

                    infoDiv.style.pointerEvents = "auto";
                    infoDetails.style.pointerEvents = "auto";
                    infoDetails.addEventListener("pointerdown", (e) => {
                        scope.controls.dispose();
                        scope.controls_Editor.dispose();
                        let flag = InfoTitle.getElementsByClassName('name')[0].innerText;
                        getMCid(getIndexByValue(flag), cMType);
                    })
                    const mInfoLabel = new CSS2DObject(infoDiv);
                    SetLabelPos(index, mInfoLabel, model);
                    scope.divLabel[index] = mInfoLabel;
                    scope.mixer[index] = new THREE.AnimationMixer(model.scene);
                    scope.action[index] = scope.mixer[index].clipAction(model.animations[0]);
                    scope.action[index].play();
                    scope.getMachineMove();
                } else {
                    scope.mixer[index] = new THREE.AnimationMixer(model.scene);
                    scope.action[index] = scope.mixer[index].clipAction(model.animations[0]);
                    scope.action[index].play();
                }
            }, function (xhr) {
                //console.log(xhr.loaded);
                if ((xhr.loaded / scope.ModelSize[index] * 100).toFixed(0) * 1 === 100) {
                    getProgress(99)
                    setTimeout(() => {
                        getProgress(100)
                    }, 500);
                }
            })
        }

        function SetLabelPos(index, label, model) {
            label.position.set(model.scene.children[0].position.x, 1.7, -1.5);
            if (index == 0) {
                label.position.set(model.scene.children[0].position.x - 1.7, 1.3, -1.5);
            } else if (index == 1) {
                label.position.set(model.scene.children[0].position.x, 3, -1.5);
            }
            else if (index > 6 && index != 14) {
                label.position.set(model.scene.children[0].position.x, 2.2, -1.5);
            }
            else if (index == 14) {
                label.position.set(model.scene.children[0].position.x + 0.25, 2.2, -1.5);
            }
            model.scene.add(label)
        }

        function getIndexByValue(value) {
            let index = 0;

            for (let i = 0; i < scope.deviceName.length; i++) {
                if (scope.deviceName[i] == value) {
                    index = i;
                    break;
                }
            }
            return index;
        }

        function LoadGLBModel_other(url) {
            let loader = new GLTFLoader();
            loader.load(url, function (model) {
                model.scene.scale.set(0.6, 0.6, 0.6);
                model.scene.traverse(function (child) {
                    if (child.isMesh) {
                        child.material.color = new THREE.Color(0x0000ff);
                    }
                })
                model.scene.position.set(0.75, 0.98, -1.240);
                let pos = [
                    { x: -16.56, y: 0.59, z: -1.05 },
                    { x: -15, y: 2.5, z: -1.08 },
                    { x: -10.55, y: 0.94, z: -1.05 },
                    { x: -7.15, y: 0.72, z: -1.14 },
                    { x: -4.92, y: 0.82, z: -1.14 },
                    { x: -2.33, y: 1.02, z: -1.14 },
                    { x: 0.75, y: 0.96, z: -1.24 },
                    { x: 2.92, y: 1.31, z: -1.14 },
                    { x: 4.6, y: 1.31, z: -1.14 },
                    { x: 6.84, y: 1.31, z: -1.14 },
                    { x: 8.75, y: 1.34, z: -1.14 },
                    { x: 11.08, y: 1.51, z: -1.14 },
                    { x: 13.76, y: 1.33, z: -1.14 },
                    { x: 16.42, y: 1.21, z: -1.14 },
                    { x: 18.3, y: 1.31, z: -1.14 }

                ]
                for (let i = 0; i < pos.length; i++) {
                    let tipsC = SkeletonUtils.clone(model.scene);
                    tipsC.position.set(pos[i].x, pos[i].y, pos[i].z)
                    scope.scene.add(tipsC);
                    let m = new THREE.AnimationMixer(tipsC);
                    m.clipAction(model.animations[0]).play();
                    scope.mTipsClone.push(m);
                    scope.tips.push(tipsC);
                    for (let i = 0; i < tipsC.children[0].children[0].children.length; i++) {
                        tipsC.children[0].children[0].children[i].material = model.scene.children[0].children[0].children[i].material.clone();
                    }
                }
            })
        }

        this.SetTips = (data) => {
            for (let i = 0; i < data.length; i++) {
                SetTipsColor(scope.tips[i], data[i]);
            }
        }

        function SetTipsColor(obj, type) {
            SetObjectChildColor(obj, type == 0 ? { x: 0xFF2B2B, y: 0xFF2B2B } : { x: 0x0000ff, y: 0x3BC5FF })
        }

        function SetObjectChildColor(obj, color) {
            if (obj != null && obj != undefined) {
                obj.traverse(function (child) {
                    if (child.isMesh) {
                        child.material.color = new THREE.Color(color.x);
                        child.material.emissive = new THREE.Color(color.y);
                    }
                });
            }
        }

        function CretaeControls(domElement, enable) {
            let controls = new OrbitControls(scope.camera, domElement);
            controls.enableDamping = true;
            if (isAlpha) {
                controls.minDistance = 0;
            } else {
                controls.minDistance = 10;
            }
            //controls.maxDistance = 13;
            controls.enabled = enable;
            scope.camera.position.set(3.57, 2.53, 5.81);
            controls.target.set(3.64, 0.5, -7.93);
            return controls;
        }

        function RomeveModel(model) {
            model.traverse(function (obj) {
                if (obj.type === 'Mesh') {
                    if (obj.material.length > 1) {
                        for (let i = 0; i < obj.material.length; i++) {
                            obj.material[i].dispose();
                        }
                    } else {
                        obj.material.dispose();
                    }
                    obj.geometry.dispose();
                    scope.scene.remove(obj);

                } else {
                    scope.scene.remove(obj)
                }
            })
        }

        this.clearScene = () => {
            cancelAnimationFrame(scope.animateID);
            if (scope.scene == null) return;
            scope.scene.traverse((child) => {
                if (child.material) {
                    if (child.material.length > 1) {
                        for (let i = 0; i < child.material.length; i++) {
                            child.material.dispose();
                        }
                    } else {
                        child.material.dispose();
                    }
                }
                if (child.geometry) {
                    child.geometry.dispose();
                }
                child = null;
            });
            scope.renderer.forceContextLoss();
            //scope.labelRenderer_2d.forceContextLoss();
            scope.renderer.dispose();
            //scope.labelRenderer_2d.dispose();
            scope.scene.clear();
            scope.scene = null;
            scope.camera = null;
            scope.controls = null;
            scope.controls_Editor = null;
            scope.renderer.domElement = null;
            scope.labelRenderer_2d.domElement = null;
            scope.renderer = null;
            scope.sceneDomElement = null;
            scope.AllModel = null;
        }

        this.SetRenderAlpha = (visible) => {
            scope.renderer.alpha = visible;
        }

        function ChangeModel_init(index) {
            if (scope.Model != null) {
                RomeveModel(scope.Model);
            }
            if (index == 0) {
                LoadGLBModel('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/0上料搅拌.glb', index);
            } else {
                LoadGLBModel('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/' + index + scope.deviceName[index] + '.glb', index);
            }
            //console.log(index);
            scope.camera.position.set(scope.AloneCameraPos[index].x, scope.AloneCameraPos[index].y, scope.AloneCameraPos[index].z)
            scope.controls_Editor.target.set(scope.AloneControlsTarget[index].x, scope.AloneControlsTarget[index].y, scope.AloneControlsTarget[index].z)
        }

        this.ChangeModel = (index) => {
            if (scope.Model != null) {
                RomeveModel(scope.Model);
            }
            if (index == 0) {
                LoadGLBModel('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/0上料搅拌.glb', index);
            } else {
                LoadGLBModel('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/' + index + scope.deviceName[index] + '.glb', index);
            }

            //console.log(index);
            scope.camera.position.set(scope.AloneCameraPos[index].x, scope.AloneCameraPos[index].y, scope.AloneCameraPos[index].z)
            scope.controls_Editor.target.set(scope.AloneControlsTarget[index].x, scope.AloneControlsTarget[index].y, scope.AloneControlsTarget[index].z)
        }

        this.ShowWorkShop = (visible) => {
            if (scope.controls == null) return;
            scope.WorkShop.visible = visible;
            if (visible) {
                scope.divLabel.forEach(item => {
                    item.visible = !visible;
                });
                SetControlsKey(1);
                scope.controls.maxDistance = 30;
                scope.MoveCamera({ x: -0.175, y: 7.33, z: 17.91 }, { x: -0.016, y: 1.53, z: -8.53 }, 2000);

            } else {
                scope.MoveCamera({ x: -2.23, y: 1.43, z: 4.23 }, { x: -2.28, y: 1.08, z: -8.62 }, 2000);
                setTimeout(() => {
                    scope.controls.maxDistance = 13;
                    SetControlsKey(0);
                    scope.divLabel.forEach(item => {
                        item.visible = !visible;
                    });
                }, 2000);
            }

        }

        function SetControlsKey(type) {
            scope.controls.mouseButtons = {
                LEFT: type == 0 ? THREE.MOUSE.PAN : THREE.MOUSE.ROTATE,
                MIDDLE: THREE.MOUSE.DOLLY,
                RIGHT: THREE.MOUSE.PAN
            }
            scope.controls.touches = {
                ONE: type == 0 ? THREE.TOUCH.PAN : THREE.TOUCH.ROTATE,
                TWO: THREE.TOUCH.DOLLY_PAN
            }
        }

        this.MoveCamera = (CameraPos, TargetPos, time) => {
            const tmpCamera = scope.camera.position;
            const tmpCtrl = scope.controls.target;
            scope.controls.rotateSpeed = 0;
            scope.controls.panSpeed = 0;
            scope.controls_Editor.rotateSpeed = 0;
            scope.controls_Editor.panSpeed = 0;

            var Cameratween = new TWEEN.Tween(tmpCamera)
                .to(CameraPos, time)
                .easing(TWEEN.Easing.Quadratic.InOut)
                .start();
            var Ctrltween = new TWEEN.Tween(tmpCtrl)
                .to(TargetPos, time)
                .easing(TWEEN.Easing.Quadratic.InOut)
                .start();
            var update = function () {
                if (scope.camera == null) return;
                scope.camera.position.set(tmpCamera.x, tmpCamera.y, tmpCamera.z);
                scope.controls.target.set(tmpCtrl.x, tmpCtrl.y, tmpCtrl.z);
                scope.controls_Editor.target.set(tmpCtrl.x, tmpCtrl.y, tmpCtrl.z);
                scope.camera.lookAt(scope.controls.target);
            };
            Cameratween.onUpdate(update);
            setTimeout(function () {
                if (scope.controls == null) return;
                scope.controls.rotateSpeed = 1.0;
                scope.controls.panSpeed = 1.0;
                scope.controls_Editor.rotateSpeed = 1.0;
                scope.controls_Editor.panSpeed = 1.0;
            }, time);
            return Cameratween;
        }

        this.EnterEditor = () => {
            if (scope.labelRenderer_2d.domElement == null) return;
            //隐藏车间
            scope.ShowWorkShop(false);
            scope.labelRenderer_2d.domElement.style.pointerEvents = 'none';
            scope.controls_Editor.enabled = true;
            scope.controls.enabled = false;
            //scope.controls_Editor.target.set(scope.controls.target.x,scope.controls.target.y,scope.controls.target.z);
            scope.cM.visible = true;
        }

        this.ExitEditor = () => {
            if (scope.labelRenderer_2d.domElement == null) return;
            scope.labelRenderer_2d.domElement.style.pointerEvents = 'auto';
            scope.controls_Editor.enabled = false;
            scope.controls.enabled = true;
            //scope.controls.target.set(scope.controls_Editor.target.x, scope.controls_Editor.target.y, scope.controls_Editor.target.z)
            scope.cM.visible = false;
            //scope.MoveCamera({ x: -0.175, y: 7.33, z: 17.91 }, { x: -0.016, y: 1.53, z: -8.53 }, 2000);
            scope.MoveCamera({ x: -2.23, y: 1.43, z: 4.23 }, { x: -2.28, y: 1.08, z: -8.62 }, 2000);


        }

        this.SetcMType_out = (num) => {
            cMType = num;
            SetcMType(num);
        }

        function SetcMType(num) {
            ChangeModelData_init(num);
            Change5Model(num);
        }

        this.ChangeModelData = (num) => {
            ChangeModelData_init(num)
        }

        function ChangeModelData_init(num) {
            if (num == 0) {
                scope.ModelSize[6] = 1626100;
                scope.deviceName[6] = '卷绕机';
                scope.isMoveType[6] = animaType[scope.divArray.length].isShow;
            } else {
                scope.deviceName[6] = '叠片机';
                scope.ModelSize[6] = 1331380;
                scope.isMoveType[6] = animaType[6].isShow;
            }
        }

        function Change5Model(isJRJ) {
            if (scope.AllModel == null) return;
            if (scope.AllModel[scope.divArray.length] != null && scope.AllModel[6] != null) {
                if (isJRJ == 0) {
                    scope.AllModel[6].visible = false;
                    scope.AllModel[scope.divArray.length].visible = true;
                } else {
                    scope.AllModel[6].visible = true;
                    scope.AllModel[scope.divArray.length].visible = false;
                }
            }
        }


        function CreateLine(model) {
            var lineMaterial = new THREE.LineBasicMaterial({
                // 线的颜色
                //color: "#ffffff",
                color: "#000000",
                transparent: true,
                linewidth: 1,
                opacity: 0.1,
                //depthTest: true,

            });
            //解决z-flighting
            lineMaterial.polygonOffset = true;
            lineMaterial.depthTest = true;
            lineMaterial.polygonOffsetFactor = 1;
            lineMaterial.polygonOffsetUnits = 1.0;
            let edges = new THREE.EdgesGeometry(model.geometry, 1);
            let lineS = new THREE.LineSegments(edges, lineMaterial);
            let lines2 = lineS.clone();
            lineS.add(lines2);
            return lineS
        }

        this.getMachineMove = () => {
            let i = 0;
            animaType.forEach(item => {
                scope.isMoveType[i] = item.isShow;
                i++;
            });
            scope.isMoveType[20] = 1;
        }

        this.GetDivArray = (array) => {
            scope.camera.position.set(-2.23, 1.43, 4.23);
            scope.controls.target.set(-2.28, 1.08, -8.62);
            scope.divArray = array;
            for (let i = 0; i < scope.divArray.length; i++) {
                // if (i > 14) {
                //     break;
                // }
                LoadGLBModel("https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/" + i + scope.deviceName[i] + ".glb", i);
            }
            LoadGLBModel("https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/model/6卷绕机.glb", scope.divArray.length);
        }

        function render() {
            scope.renderer.render(scope.scene, scope.camera);
            scope.labelRenderer_2d.render(scope.scene, scope.camera);
        }
        /**
         * @李烁滔
         * update函数
         * 每帧调用
         */
        function update() {
            render();
            scope.delta = scope.clock.getDelta();
            if (scope.controls.enabled) {
                scope.controls.update();
            }
            if (scope.controls_Editor.enabled) {
                scope.controls_Editor.update();
            }
            if (scope.ConveyorBeltUV != null) {
                for (let i = 0; i < scope.ConveyorBeltUV.length; i++) {
                    if (scope.isMoveType[i] == 1 && scope.ConveyorBeltUV[i] != null) {
                        scope.ConveyorBeltUV[i].forEach(item => {
                            item.offset.x -= 0.05;
                        });
                    }

                }
            }
            if (scope.ConveyorBeltUV_2 != null) {
                for (let i = 0; i < scope.ConveyorBeltUV_2.length; i++) {
                    if (scope.isMoveType[i] == 1 && scope.ConveyorBeltUV_2[i] != null) {
                        scope.ConveyorBeltUV_2[i].forEach(item => {
                            item.offset.x -= 0.01;
                        });
                    }

                }
            }
            if (scope.ConveyorBeltUV_3 != null) {
                for (let i = 0; i < scope.ConveyorBeltUV_3.length; i++) {
                    if (scope.isMoveType[i] == 1 && scope.ConveyorBeltUV_3[i] != null) {
                        scope.ConveyorBeltUV_3[i].forEach(item => {
                            item.offset.y -= 0.005;
                        });
                    }
                }
            }
            if (scope.ConveyorBeltUV_4 != null) {
                for (let i = 0; i < scope.ConveyorBeltUV_4.length; i++) {
                    if (scope.isMoveType[i] == 1 && scope.ConveyorBeltUV_4[i] != null) {
                        scope.ConveyorBeltUV_4[i].forEach(item => {
                            item.offset.y -= 0.02;
                        });
                    }

                }
            }
            if (scope.mixer.length > 0) {
                for (let i = 0; i < scope.mixer.length; i++) {
                    if (scope.isMoveType[i] == 1 && scope.mixer[i] != null) {
                        scope.mixer[i].update(scope.delta);
                    }
                }
            }
            if (scope.mTipsClone != null) {
                scope.mTipsClone.forEach(item => {
                    item.update(scope.delta);
                });
            }
            TWEEN.update();
            scope.animateID = requestAnimationFrame(update);
        }

        //加载环境贴图
        function LoadSceneTexture() {
            scope.skyBox = new THREE.CubeTextureLoader().setPath('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/SkyBox/BlueSky/')
                .load([
                    '1.jpg', //+x
                    '2.jpg', //-x
                    '3.jpg', //+y
                    '4.jpg', //-y
                    '5.jpg', //+z
                    '6.jpg' //-z
                ], function onProgress(xhr) {
                    scope.scene.background = scope.skyBox;
                });
        }

        //加载反射贴图
        function LoadEnvironmentTexture() {
            scope.environment = new THREE.CubeTextureLoader().setPath('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/SkyBox/HDR056/')
                .load([
                    "Left.png", // +x
                    "Right.png", // -x
                    "Up.png", // +y
                    "Down.png", // -y
                    "Forward.png", // +z
                    "Back.png", // -z
                ], function onProgress(xhr) {
                    //scope.scene.background = scope.environment;
                });
        }
    }
} export default ThreeDimensional;

